module.exports = __webpack_public_path__ + "static/img/botton_zixun.c7dde8c4.png";